export class ReferralNotExists extends Error {
  constructor() {
    super('Referral does not exist');
  }
}
